import Service from "../../../Services/index";
import moment from "moment";

const ElectricityBill = {
    namespaced: true,
    state: {
        electricityBillList:[],
        electricityBillByRentalFeeID:"",
        form:{
            id: "",
            rental_fee_id : "",
            unit_before : 0,
            unit_after : "",
            total_unit : "",
            total_price : "",
            record_name: "",
            date_record : '',
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },

    },
    mutations: {
        GET_ELECTRICITY_BILL: (state, res) => {
            state.electricityBillList = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_ELECTRICITY_BILL_BY_RENTAL_FEE_ID: (state, res) => {
            state.electricityBillByRentalFeeID = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_ELECTRICITY_BILL_BY_ID: (state, res) => {
            state.form = res;
        },
        CLEAR_FORM_DATA : (state)=>{
            state.form = {
                unit_before : '',
                unit_after : "",
                total_unit : "",
                total_price : "",
                record_name: "",
                date_record : '',
            }
        }
    },
    actions: {
        setElectricityBill({commit},{rental_fee_id,page=1}){
            return Service.ElectricityBill.getElectricityBill(page,rental_fee_id).then(data=>{
                commit("GET_ELECTRICITY_BILL",data);
            })
        },
        saveElectricityBill({commit},{id,data}){
            if(!id){
                return Service.ElectricityBill.createElectricityBill(data).then(res=>{
                    console.log("create");
                });
            }
            else{
                return Service.ElectricityBill.updateElectricityBill(id,data).then(res=>{
                    console.log("update");
                });
            }
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        showElectricityBillByID({commit},id){
            console.log(id)
            return Service.ElectricityBill.showElectricityBill(id).then(res=>{
                console.log(res);
                commit("GET_ELECTRICITY_BILL_BY_ID",res);
            })
        },
        delete({ commit }, id) {
            return Service.ElectricityBill.deleteElectricityBill(id)
                .then(() => {
                    console.log("delete rental Fee");
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getElectricityBillByRentalFeeID({commit},rental_fee_id,page=1){
            return Service.ElectricityBill.getElectricityBillByRentalFeeID(rental_fee_id,page).then(res=>{
                commit("GET_ELECTRICITY_BILL_BY_RENTAL_FEE_ID",res)
            })
        },
    }
};

export default ElectricityBill;
